import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { AuthProvider } from "@/lib/auth";

// Silence the benign ResizeObserver dev warnings that CRA's error overlay
// otherwise renders as a full-screen modal (Radix UI Select/Dialog trigger
// this internally without any functional impact).
const RESIZE_OBS_MSG = "ResizeObserver loop";
window.addEventListener(
  "error",
  (e) => {
    if (e?.message && e.message.includes(RESIZE_OBS_MSG)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  },
  true,
);
window.addEventListener("unhandledrejection", (e) => {
  const msg =
    typeof e?.reason === "string" ? e.reason : e?.reason?.message || "";
  if (msg.includes(RESIZE_OBS_MSG)) {
    e.preventDefault();
  }
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
